import { render, staticRenderFns } from "./userInfo.vue?vue&type=template&id=08162d1f&scoped=true"
import script from "./userInfo.vue?vue&type=script&lang=js"
export * from "./userInfo.vue?vue&type=script&lang=js"
import style0 from "./userInfo.vue?vue&type=style&index=0&id=08162d1f&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08162d1f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08162d1f')) {
      api.createRecord('08162d1f', component.options)
    } else {
      api.reload('08162d1f', component.options)
    }
    module.hot.accept("./userInfo.vue?vue&type=template&id=08162d1f&scoped=true", function () {
      api.rerender('08162d1f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/platformManage/components/userInfo.vue"
export default component.exports